// This will show the mfe when the path is exact
export function showWhenAnyOf(routes) {
    return function (location) {
      return routes.some(route => location.pathname === route);
    };
  }
  
  // This will show the mfe when the path starts with
  export function showWhenPrefix(routes) {
    return function (location) {
      return routes.some(route => location.pathname.startsWith(route));
    };
  }
  
  // This will hide the mfe when path
  export function showExcept(routes) {
    return function ({ pathname }) {
      return routes.every(route => {
        const regex = new RegExp(`^${route}.*`, 'i');
        return !regex.test(pathname);
      });
    };
  }
  